<template>
    <div class="myCard text-center">
        <div class="cardBody">
            <div class="title">
                <div class="iconContainer">
                    <i :class="`fas ${this.icon} fa-3x icon`"></i>
                </div>
                <h1>{{ this.title }}</h1>
            </div>

            <div class="main">
                <slot></slot>
            </div>

            <div class="bottom">
                <template v-if="hasButton">
                <div class="divider divider-small divider-small-center">
                    <hr>
                </div>
                <button class="btn btn-primary mr-1" type="button">
                    <a :href="buttonHref">{{ buttonTitle }}</a>
                </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewIconBox",
    props: {
        icon: {
            type: String,
            default: function() {
                return "fas fa-cogs"
            }
        },
        title: {
            type: String,
            required: true,
            default: function() {
                return "NO TITLE"
            }
        },
        buttonTitle: {
            type: String,
            required: false,
            default: function() {
                return undefined;
            }
        },
        buttonHref: {
            type: String,
            required: false,
            default: function() {
                return undefined
            }
        }
    },
    computed: {
        hasButton: function() {
            return this.buttonTitle !== undefined && this.buttonHref !== undefined;
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;
    $icon-size: 80px;
    
    .myCard {
        border: 1px solid rgba(0,0,0,.125);
        border-radius: $border-radius;
        border-top-width: $border-radius;
        border-top-color: $primary-color !important;
        height: 100%;
        width: 100%;
    }

    .cardBody {
        display: flex;
        flex-flow: column;
        height: 100%;
        width: 100%;
        padding: 1.25rem;
    }

    h1 {
        word-break: break-word;
        min-height: 100px !important;
        display: flex;
         flex-direction: column;
        justify-content: center;
    }

    .main {
        flex: 2;
        overflow: auto;
         display: flex;
         flex-direction: column;
        justify-content: center;

        p {
            margin: 0;
        }
    }

    .bottom {
        height: 115px;
    }

    .iconContainer {
        height: $icon-size; 
        line-height: $icon-size;
        margin-bottom: 20px;
    }

    .icon {
        background-color: $primary-color; 
        height: 100%; 
        width: $icon-size; 
        border-radius: calc(#{$icon-size} / 2); 
        line-height: inherit
    }

    .fas {
        color: white;
    }

    .divider > hr {
        background-color: $primary-color !important;
    }

a {
        color: white;
        text-decoration: none;
    }

    button {
        border-radius: $border-radius;
        border: none;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    h1 {
        font-size: 2em;
        margin-bottom: 10px;
        margin-top: 10px;
    }






</style>